import * as States from '@/constants/states';

// Combine all constants
const constants = { ...States };

export default defineNuxtPlugin(nuxtApp => {
  // Inject constants into the app
  nuxtApp.provide('constants', constants);
});
